export const requiredFields = field => {
  switch (field) {
    case 'email':
      return 'Ingen mejladress angiven'
    case 'name':
      return 'Namn saknas'
    case 'title':
      return 'Rubrik saknas'
    case 'message':
      return 'Meddelande saknas'
    default:
      return ''
  }
}



// WEBPACK FOOTER //
// ./src/utils/requiredFields.js